// extracted by mini-css-extract-plugin
export default {"previewHeader":"styles---previewHeader---QCyZG","previewDescription":"styles---previewDescription---iq2Zc"};